import { IAction, ICondition } from '../../interfaces';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subscription } from 'rxjs/Subscription';

export abstract class BaseAction implements IAction {
    private subscription: Subscription;

    nextAction: IAction;
    conditions: ICondition[] = [];

    abstract act(): void;

    addCondition(condition: ICondition): void {
        this.conditions.push(condition);
    }

    invoke() {
        if (!this.conditions || !this.conditions.length) {
            this.act();
            return;
        }

        this.subscription = combineLatest(this.conditions.map(c => c.observable))
            .subscribe((values) => {
                // exit if any condition failed
                if (values.some(v => !v)) { return; }

                console.log(`Running ${this.constructor.name} action...`);
                this.act();
            });
    }

    cancel(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
